import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ResponseDefault } from 'src/app/shared/data/response-default.interface';
import { BaseService } from 'src/app/shared/services/base.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { environment } from 'src/environments/environment';
import { ESolicitacaoConsultaStatus, IConsulta, ISolicitacaoConsultaFiltros, ISolicitaoConsulta } from '../data/consultas';

@Injectable({
  providedIn: 'root'
})
export class ConsultasService extends BaseService {
  private readonly apiUrl = `${this.urlService}${environment.microservices.doctor}`;
  hasConsultasPendentes$ = new BehaviorSubject<boolean>(false);

  constructor(private readonly httpClient: HttpClient, private readonly toastService: ToastService) {
    super(toastService);
  }

  listarTodasSolicitacoesConsultas(
    filtros: ISolicitacaoConsultaFiltros
  ): Observable<ResponseDefault<ISolicitaoConsulta[]>> {
    return this.httpClient.post<ResponseDefault<ISolicitaoConsulta[]>>(
      `${this.apiUrl}MedicalAppointmentRequest/ListByFilterAsync`,
      filtros
    ).pipe(tap(result => {
      if(result.isSucceed){
        if(filtros.status == ESolicitacaoConsultaStatus.pendenteAprovacao){
          const hasConsultas = result.count ? result.count > 0 : false;
          this.hasConsultasPendentes$.next(hasConsultas);
        }
      }
    }));
  }

  getDadosSolicitacaoConsulta(id: string): Observable<ResponseDefault<ISolicitaoConsulta>> {
    return this.httpClient.get<ResponseDefault<ISolicitaoConsulta>>(`${this.apiUrl}MedicalAppointmentRequest/${id}`);
  }

  criarConsulta(consulta: IConsulta): Observable<ResponseDefault<boolean>> {
    return this.httpClient.post<ResponseDefault<boolean>>(`${this.apiUrl}MedicalAppointment`, consulta);
  }
}
